import { FC } from 'react'
import s from './RestaurantQuickFilter.module.sass'

import { FilterItemSkeleton } from '@widgets/Restaurant/RestaurantQuickFilter/ui/FilterItem'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

interface Props {
  className?: string
}

const Skeleton: FC<Props> = ({ className = '' }) => {
  const arraySkeleton = Array.from(Array(8).keys())

  return (
    <BlockBoundary>
      <div className={`${s['wrapper-skeleton']} ${className}`}>
        {arraySkeleton.map((_el, index) => (
          <FilterItemSkeleton key={index} />
        ))}
      </div>
    </BlockBoundary>
  )
}

export default Skeleton
